import { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import { alpha, useTheme } from '@mui/material/styles';
import ImageNotSupportedIcon from '@mui/icons-material/ImageNotSupported';

export interface RowImageProps {
    src: string | null | undefined;
    size: number;
}

export function RowImage({ src, size }: RowImageProps) {
    const theme = useTheme();
    const [failed, setFailed] = useState(false);

    useEffect(() => {
        setFailed(false);
    }, [src]);

    if (!src || failed) {
        return (
            <Box
                sx={{
                    width: size,
                    height: size,
                    borderRadius: '3px',
                    flexShrink: 0,
                    mt: '1px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    bgcolor: alpha(theme.palette.text.primary, 0.06),
                    color: alpha(theme.palette.text.primary, 0.25),
                }}
            >
                <ImageNotSupportedIcon sx={{ fontSize: Math.round(size * 0.55) }} />
            </Box>
        );
    }

    return (
        <Box
            component="img"
            src={src}
            alt=""
            loading="lazy"
            referrerPolicy="no-referrer"
            onError={() => setFailed(true)}
            sx={{
                width: size,
                height: size,
                borderRadius: '3px',
                objectFit: 'cover',
                flexShrink: 0,
                mt: '1px',
                bgcolor: alpha(theme.palette.text.primary, 0.06),
            }}
        />
    );
}